// Stage 0 deliberately does not rebuild business screens (per the v6
// architecture doc §8, Stage 0 is the platform Stage 1 builds on). These
// routes exist now so the real URL structure, navigation, and shell are
// in place end-to-end; each becomes a real screen in its own later stage.
export function PlaceholderPage({ title, stage }: { title: string; stage: string }) {
  return (
    <div className="space-y-2">
      <h1 className="text-2xl font-extrabold tracking-tight text-white">{title}</h1>
      <p className="text-sm text-slate-400">
        This screen is not built yet. It arrives in {stage} of the v6 migration — see
        docs/V6_ARCHITECTURE_AND_MIGRATION_PLAN.md.
      </p>
    </div>
  );
}
